import { Button, ButtonProps } from '../Button';
import React from 'react';

export interface IconButtonProps
    extends Omit<
        ButtonProps,
        'children' | 'icon' | 'iconPosition' | 'fullWidth' | 'size'
    > {
    icon: string;
    size?: 'xs' | 'sm' | 'md' | 'lg';
}

const sizeMap = {
    xs: '22px',
    sm: '32px',
    md: '36px',
    lg: '40px',
};

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
    ({ icon, size = 'md', variant = 'outlined', sx, ...rest }, ref) => {
        const dimension = sizeMap[size];

        return (
            <Button
                ref={ref}
                icon={icon}
                variant={variant}
                sx={{
                    width: dimension,
                    height: dimension,
                    minWidth: dimension,
                    padding: 0,
                    ...sx,
                }}
                {...rest}
            />
        );
    }
);

IconButton.displayName = 'IconButton';
